










































import Vue from 'vue';
import CustomerFilterDisplayBox from './CustomerFilterDisplayBox.vue';
import customerVuex from '../../../customer/vuex/common';
import CustomerExpectedCount from '../common/CustomerExpectedCount.vue';
import queryMaker from '@/customer/components/filter/makeCustomerQuery';
import massClient from '@/mass/apis';

export default Vue.extend({
  data() {
    return {
      enableExclude: false,
      excludeDays: 0, // 0代表当天而不是0天
      counts: {} as any,
      isLoading: false,
      loaded: false,
    }
  },
  props: {
    showExclude: {
      type: Boolean,
      default: false,
    },
    exclude: {
      type: Object,
    },
  },
  mixins: [customerVuex],
  components: {
    CustomerFilterDisplayBox,
    CustomerExpectedCount,
  },
  methods: {
    emitExcludeSetting(): void {
      if(this.enableExclude) {
        this.$emit('excludeChange',this.excludeRangeFor(this.excludeDays));
      } else {
        this.$emit('excludeChange', null);
      }
    },
    setTotal(val: number) {
      this.$emit('setExpectCount', val);
    },
    excludeRangeFor(days: number): any {
      switch(days) {
        case 0:
          return {
            Today: {},
          }
        default:
          return {
            Days: { n: days },
          }
      }
    },
    countSent(): void {
      if(!this.isLoading) {
        this.isLoading = true;
        const filter = queryMaker.mkFilterQueries(this.customerFilter);
        const days = [0, 3, 7, 15];
        const promises = days.map((d) => {
          const q = {
            query: filter,
            exclude: this.excludeRangeFor(d),
          }
          massClient.countSent(q).success((r) => {
            Vue.set(this.counts, `${d}`, r);
          }).promise;
        });
        Promise.all(promises).then(() => {
          setTimeout(() => {
            this.isLoading = false;
            this.loaded = true;
          }, 500);
        });
      }
    },
  },
  mounted() {
    if(this.exclude && this.exclude.Today) {
      this.excludeDays = 0;
      this.enableExclude = true;
    } else if(this.exclude && this.exclude.Days) {
      this.excludeDays = this.exclude.Days.n;
      this.enableExclude = true;
    }
  },
});
